import { render, staticRenderFns } from "./SmsHistView.vue?vue&type=template&id=6ae18e52&scoped=true"
import script from "./SmsHistView.vue?vue&type=script&lang=js"
export * from "./SmsHistView.vue?vue&type=script&lang=js"
import style0 from "./SmsHistView.vue?vue&type=style&index=0&id=6ae18e52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae18e52",
  null
  
)

export default component.exports